import {useAuth0} from './Auth0';
import {ENVIRONMENT} from '../../configuration';
import AppErrorBoundary from './AppErrorBoundary';
import { GetTokenSilentlyOptions, User } from '@auth0/auth0-react';

interface Props {
	children: (props: {
		user: User | undefined;
		getTokenSilently: (payload?: GetTokenSilentlyOptions) => Promise<string>;
	}) => JSX.Element | null;
}

const AppAuthenticate = ({ children }: Props) => {
	const {isAuthenticated, loginWithRedirect, loading, user, getTokenSilently} = useAuth0();

	if (loading) return null;

	if (ENVIRONMENT === 'development') {
		return (
			<AppErrorBoundary>
				{children({ user, getTokenSilently: () => Promise.resolve('')})}
			</AppErrorBoundary>
		);
	}

	if (ENVIRONMENT === 'production' && isAuthenticated) {
		return (
			<AppErrorBoundary>
				{children({ user, getTokenSilently})}
			</AppErrorBoundary>
		);
	}

	if (ENVIRONMENT === 'production' && !isAuthenticated) {
		loginWithRedirect({
			appState: {targetUrl: window.location.pathname + window.location.search + window.location.hash },
		});
		return null;
	}

	return null;
};

export default AppAuthenticate;
